import React from 'react';

interface EllipseIconProps {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}

const EllipseIcon: React.FC<EllipseIconProps> = ({ 
  width = 18, 
  height = 18, 
  fill = "none",
  stroke = "#DBDBDB",
  strokeWidth = 2,
  className 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 18 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle 
        cx="9" 
        cy="9" 
        r="8" 
        fill={fill} 
        stroke={stroke} 
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default EllipseIcon; 